import {
  BD_SHARE_PERMISSION_DISPLAY_NAME,
  BdSharePermission,
} from '@bindoc-projects/resource-domain-lib';

const displayName = BD_SHARE_PERMISSION_DISPLAY_NAME['de'];

export class BdSharePermissionInfo {
  constructor(
    public permission: BdSharePermission,
    public explanation: string,
    public weight: number,
  ) {}

  public static of(permission: BdSharePermission): BdSharePermissionInfo {
    const info = BD_SHARE_PERMISSION_INFOS.find(
      (i) => i.permission === permission,
    );
    if (!info) {
      throw new Error(`Unknown permission: ${permission}`);
    }
    return info;
  }

  /**
   * Returns the cumulative permission tree below `permission` (inclusive).
   * `tree('READ')` → `[READ]`
   * `tree('UPDATE')` → `[READ, UPDATE]`
   * `tree('DELETE')` → `[READ, UPDATE, DELETE]`
   */
  public static tree(permission: BdSharePermission): BdSharePermissionInfo[] {
    const target = BdSharePermissionInfo.of(permission);
    return BD_SHARE_PERMISSION_INFOS.filter((i) => i.weight <= target.weight);
  }
}

export const BD_SHARE_PERMISSION_INFOS: BdSharePermissionInfo[] = [
  new BdSharePermissionInfo('READ', displayName['READ'], 1),
  new BdSharePermissionInfo('UPDATE', displayName['UPDATE'], 2),
  new BdSharePermissionInfo('DELETE', displayName['DELETE'], 3),
];
